import type {
  AlignmentValue,
  DateValue,
  LanguageValue,
  TextStyleValue,
  TimeFormatValue,
  TimeRangeValue
} from '@elfsight/configurator-contracts';

export type WorkHoursInterval = [Date, Date];

export enum Weekday {
  sunday = 'sunday',
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  saturday = 'saturday'
}

export type WorkingHours = {
  id: string;
  timeRange: TimeRangeValue;
};

export type DayMonthFormat = 'short' | 'full';

export type SpecialIntervalType = 'closed' | 'specialHours';

export type RawSpecialInterval = {
  id: string;
  startDate: DateValue;
  endDate: DateValue;
  type: SpecialIntervalType;
  workingHours: WorkingHours[];
  description: string;
};

export type BusinessHoursMode = 'status' | 'statusWithHours' | 'hours';

export interface BusinessHoursProps {
  mode: BusinessHoursMode;
  language: LanguageValue;
  timeZone: string | undefined;
  timeFormat: TimeFormatValue;
  openStatusColor: string;
  closedSoonStatusColor: string;
  closedStatusColor: string;

  textStyle: TextStyleValue;
  textColor: string;

  alignment: AlignmentValue;
  firstWeekday?: Weekday;
  specialIntervals: RawSpecialInterval[];
  daySundayHours: WorkingHours[];
  daySundayOpen: boolean;
  dayMondayHours: WorkingHours[];
  dayMondayOpen: boolean;
  dayTuesdayHours: WorkingHours[];
  dayTuesdayOpen: boolean;
  dayWednesdayHours: WorkingHours[];
  dayWednesdayOpen: boolean;
  dayThursdayHours: WorkingHours[];
  dayThursdayOpen: boolean;
  dayFridayHours: WorkingHours[];
  dayFridayOpen: boolean;
  daySaturdayHours: WorkingHours[];
  daySaturdayOpen: boolean;
  dayMonthFormat: DayMonthFormat;
}
